export default "__VITE_ASSET__DnbErTG8__"